import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'featured-chef-item',
  templateUrl: './featured-chef-item.component.html',
  styleUrls: ['./featured-chef-item.component.scss']
})
export class FeaturedChefItemComponent implements OnInit {

  @Input() chefName!: string
  @Input() cuisineName!: string
  @Input() chefImage!: string
  @Input() slugName!: string

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): void {

  }

  viewMerchant() {
    this.router.navigate(['/page', this.slugName])
  }

  getImage() {
    if (this.chefImage.length !== 0)
    return `url("${this.chefImage}")`
    else
      return `url(/assets/merchant-placeholder.svg)`
  }
}
